import React from 'react'
import { Button} from 'react-bootstrap'
import { Search, X } from 'react-bootstrap-icons'

export default ({
    onClick = () => {},
    hasValue,
    disabled
}) => {
    const Icon = hasValue ? X : Search;
    return (
        <Button
            variant="primary"
            disabled={disabled}
            onClick={onClick}
        >
            <Icon size={18} />
        </Button>
    )
}